import React from 'react'
import './BucketVersionHeading.scss'
import Switch from '../dataEntry/inputs/Switch'
import { Icon } from 'antd'
import ButtonContainer from '../general/buttons/ButtonContainer'
import SearchButton from '../general/buttons/SearchButton'
import CopyLinkButton from '../general/buttons/CopyLinkButton'
import DeleteButton from '../general/buttons/DeleteButton'
import { BUCKET_VERSION_MODAL_TYPES } from 'constants/general-constants'

const BucketVersionHeading = ({
  versionId,
  versionName = '',
  handleBucketVersionModal,
  handleVersionDeletion,
  handleBucketVersionEnableDisable,
  isEnabled,
  isSwitchLoading,
  handleCopySchedule,
  onAddSearch,
  onViewApiResponse
}) => {
  return (
    <div className='bucket-version-heading'>
      <div className='left-section'>
        {versionName && <p className='version-title' > {versionName}</p>}
        <ButtonContainer
          displayTitle='Update Schedule'
          childComponent={
            <Icon
              type='clock-circle'
              style={{ fontSize: '17px' }}
              onClick={() => handleBucketVersionModal(versionId, BUCKET_VERSION_MODAL_TYPES.UPDATE_BUCKET_VERSION_MODAL)}
            />
          }
        />
        <Switch
          isChecked={isEnabled}
          loading={isSwitchLoading}
          onChange={(flag) => handleBucketVersionEnableDisable(flag, versionId)}
        />
      </div>
      <div className='right-section'>
        <ButtonContainer
          displayTitle='Add Search Item'
          childComponent={
            <SearchButton
              onClick={() => onAddSearch(versionId)}
            />
          }
        />
        <ButtonContainer
          displayTitle='View API Response'
          childComponent={
            <CopyLinkButton
              onClick={onViewApiResponse}
            />
          }
        />
        <ButtonContainer
          displayTitle='Remove'
          childComponent={
            <DeleteButton
              onClick={() => handleVersionDeletion(versionId)}
            />
          }
        />
        <div className='black-button' onClick={() => handleCopySchedule(versionId)}>
          <ButtonContainer
            displayTitle='Copy Version'
            childComponent={
              <Icon
                type='copy'
                style={{ fontSize: '17px' }}
                theme='filled'
              />
            }
          />
        </div>
      </div>
    </div>
  )
}

export default BucketVersionHeading
